var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Legacy Site Content")]),_vm._l((_vm.groups),function(group){return _c('h3',{key:group.id},[_c('router-link',{attrs:{"to":{name: 'group', params: {groupName: group.name}}}},[_vm._v(_vm._s(group.name))])],1)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }